import React from "react";

interface IFormDropDownYearProps {
  label: string;
  id: string;
  value?: string | number;
  required?: boolean;
  disabled?: boolean;
  error?: string | undefined;
  onChange: (id: string, value: string) => void;
  hint?: string;
  min?: number; // Optional minimum year
  max?: number; // Optional maximum year
}

function FormDropDownYear({
  label,
  id,
  value,
  required,
  disabled,
  error,
  onChange,
  hint = "",
  min,
  max,
}: IFormDropDownYearProps) {
  // Generate year options from min to max (default 1900 to current year)
  const yearOptions = Array.from(
    { length: (max || new Date().getFullYear()) - (min || 1900) + 1 },
    (_, i) => {
      const year = (min || 1900) + i;
      return { value: year, label: year.toString() };
    }
  ).reverse(); // Reverse to show latest years first

  const css: string = disabled ? "form-input-disabled" : "form-input";
  return (
    <div>
      <label htmlFor={id} className="form-label">
        {label}
        {required && <>*</>}
      </label>
      <select
        name={id}
        id={id}
        value={value || ""}
        className={css}
        required={required}
        onChange={(e) => onChange(id, e.target.value)}
        disabled={disabled}
      >
        <option value="" disabled>Select a year</option>
        {yearOptions.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {hint && <div className="form-hint">{hint}</div>}
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}

export default FormDropDownYear;